module.exports = __webpack_public_path__ + "static/media/studentsplacementandhigherstudies.97cbe78e.png";